/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type NetworkFilterSchemaSourcesItem = typeof NetworkFilterSchemaSourcesItem[keyof typeof NetworkFilterSchemaSourcesItem];


export const NetworkFilterSchemaSourcesItem = {
  connections: 'connections',
  overlaps: 'overlaps',
} as const;
